import Navbar from '../components/Navbar'
import HeroSection from '../components/HeroSection'
import FeaturedListings from '../components/FeaturedListings'
import SellSection from '../components/SellSection'
import StatsSection from '../components/StatsSection'
import TeamSection from '../components/TeamSection'
import PartnersSection from '../components/PartnersSection'
import CTASection from '../components/CTASection'
import MediaSection from '../components/MediaSection'
import DubaiEvolutionSection from '../components/DubaiEvolutionSection'
import TransactionReportSection from '../components/TransactionReportSection'
import Footer from '../components/Footer'
import GoldenVisaSection from '../components/GoldenVisaSection'
import TopCommunitiesSection from '../components/TopCommunitiesSection'
import TrustSection from '../components/TrustSection'
import RecentlySoldSection from '../components/RecentlySoldSection'
import { useLanguage } from '../context/LanguageContext'

/* ─── Compact Off-Plan promo strip ──────────────────────────── */
const NAVY = '#002E53'
const GOLD = '#C5A059'
const FONT = "'Poppins', sans-serif"

function OffplanPromoStrip() {
  const { t } = useLanguage()
  return (
    <div style={{
      background: `linear-gradient(135deg, ${NAVY} 0%, #001222 100%)`,
      width: '100%',
      padding: '52px 20px',
      boxSizing: 'border-box',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{ position: 'absolute', top: '-80px', right: '-60px', width: '320px', height: '320px', borderRadius: '50%', background: `${GOLD}08`, pointerEvents: 'none' }} />
      <div style={{
        maxWidth: '1200px', margin: '0 auto',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: '24px', position: 'relative', zIndex: 1,
        width: '100%', boxSizing: 'border-box',
      }}>
        <div style={{ flex: '1 1 280px', minWidth: 0 }}>
          <span style={{
            display: 'inline-block', background: `${GOLD}22`, color: GOLD,
            fontFamily: FONT, fontSize: '11px', fontWeight: 700, letterSpacing: '1.8px',
            padding: '4px 12px', borderRadius: '50px', textTransform: 'uppercase',
            border: `1px solid ${GOLD}40`, marginBottom: '10px',
          }}>{ t('offplanPromo.badge') }</span>
          <h2 style={{
            fontFamily: FONT, fontSize: 'clamp(20px, 3vw, 34px)', fontWeight: 700,
            color: '#fff', margin: '0 0 8px', lineHeight: 1.2,
          }}>
            { t('offplanPromo.heading') }
          </h2>
          <p style={{
            fontFamily: FONT, fontSize: '15px', color: 'rgba(255,255,255,0.6)',
            margin: 0, lineHeight: 1.6, maxWidth: '520px',
          }}>
            { t('offplanPromo.desc') }
          </p>
        </div>
        <a
          href="/offplan"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '8px',
            background: GOLD, color: '#fff',
            fontFamily: FONT, fontSize: '15px', fontWeight: 700,
            padding: '15px 32px', borderRadius: '10px',
            textDecoration: 'none', whiteSpace: 'nowrap',
            transition: 'background 0.2s, transform 0.15s',
            flexShrink: 0,
          }}
          onMouseEnter={e => { e.currentTarget.style.background = '#d4af6a'; e.currentTarget.style.transform = 'translateY(-2px)' }}
          onMouseLeave={e => { e.currentTarget.style.background = GOLD; e.currentTarget.style.transform = 'translateY(0)' }}
        >
          { t('offplanPromo.btn') }
        </a>
      </div>
    </div>
  )
}

function HomePage() {
  return (
    <div className="website-wrapper wpresidence_wrapper_for_header_type1 wide" id="all_wrapper">
      <div className="container-fluid px-0 wpresidence_main_wrapper_class wide has_header_type1">
        <Navbar />
        <main className="content_wrapper container-fluid">
          <div data-elementor-type="wp-page" data-elementor-id="18618" className="elementor elementor-18618">
            <HeroSection />
            <FeaturedListings />
            <RecentlySoldSection />
            <SellSection />
            <TrustSection />
            <StatsSection />
            <div style={{ paddingTop: '60px' }}>
              <GoldenVisaSection />
            </div>
            <TeamSection />
            <PartnersSection />
            <TopCommunitiesSection />
            <OffplanPromoStrip />
            <DubaiEvolutionSection />
            <TransactionReportSection />
            <MediaSection />
            <CTASection />
          </div>
        </main>
        <Footer />
      </div>

      {/* Back to top */}
      <a href="#" className="backtop" aria-label="up"><i className="fas fa-chevron-up"></i></a>
      {/* Contact button */}
      <a href="#" className="contact-box" aria-label="contact"><i className="fas fa-envelope"></i></a>
    </div>
  )
}

export default HomePage
